import React, { useLayoutEffect } from "react";
import Layout from "./layout/Layout";
import { useLocation } from "react-router-dom";
const App = () => {
  return (
    <Wrapper>
      <Layout />
    </Wrapper>
  );
};

export default App;

const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};
